import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { TranslateService } from '@ngx-translate/core';
import { Store } from '@ngrx/store';
import * as AuthActions from '../../store/actions/auth.actions';
import { selectAuthLoading, selectAuthLogingIn } from '../../store/selectors/auth.selectors';
import { Observable } from 'rxjs';
// import { FacebookService } from '../../services/facebook.service';
declare const google: any;
// declare const FB: any;

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  standalone: false,
})
export class LoginComponent implements OnInit {
  loginForm!: FormGroup;
  isSubmitted = false;
  isLogingIn$: Observable<boolean | null>;
  isLoading$: Observable<boolean | null>;
  showPassword: boolean = false;

  // private readonly facebookService = inject(FacebookService);

  constructor(
    private fb: FormBuilder,
    private toastr: ToastrService,
    private traslate: TranslateService,
    private store: Store
  ) {
    this.isLogingIn$ = this.store.select(selectAuthLogingIn);
    this.isLoading$ = this.store.select(selectAuthLoading);
  }

  ngOnInit(): void {
    this.loginForm = this.fb.group({
      email: ['', [Validators.required, Validators.email]],
      password: ['', Validators.required],
    });

    google.accounts.id.initialize({
      client_id: '201320734760-oklcfad7g4c40tv3hnhej4dt9nchdgkn.apps.googleusercontent.com',
      callback: (response: any) => this.handleGoogleLogin(response),
    });

    google.accounts.id.renderButton(document.getElementById('google-btn'), {
      theme: 'outline',
      size: 'large',
    });
  }

  get formControls() {
    return this.loginForm.controls;
  }

  onSubmit() {
    this.isSubmitted = true;

    if (this.loginForm.invalid) {
      this.toastr.error(
        this.traslate.instant('LOGIN_FORM_ERROR'),
        this.traslate.instant('VALIDATION_ERROR')
      );
      return;
    }

    const { email, password } = this.loginForm.value;

    this.store.dispatch(AuthActions.login({ email, password }));
  }

  togglePasswordVisibility(): void {
    this.showPassword = !this.showPassword;
  }

  handleGoogleLogin(response: any) {
    const idToken = response.credential;

    this.store.dispatch(AuthActions.loginWithGmail({ idToken }));
  }

  // async loginWithFacebook() {
  //   const accessToken = await this.facebookService.login();

  //   if (accessToken) {
  //     this.store.dispatch(AuthActions.loginWithFacebook({ accessToken }));
  //   }
  // }
}
